export const formatDateKey = (d) => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getDateFromIndex = (startedAt, index) => {
  const base = startedAt.toDate ? startedAt.toDate() : new Date(startedAt);
  const d = new Date(base);
  d.setDate(base.getDate() + index);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const getDayStatusByIndex = (index, startedAt, completedDays) => {
  if (!startedAt) return "upcoming";

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const date = getDateFromIndex(startedAt, index);
  const key = formatDateKey(date);

  if (completedDays[key]) return "done";
  if (date.getTime() === today.getTime()) return "today";
  if (date < today) return "missed";
  return "upcoming";
};

export const getTotalDaysFromRoadmapRef = (roadmapRef) => {
  if (!roadmapRef?.phases) return 0;

  let count = 0;

  roadmapRef.phases.forEach((phase) => {
    phase.weeks?.forEach((week) => {
      count += week.days?.length || 0;
    });
  });

  return count;
};
